import Http from '@/network/http'

const http = new Http()

/**
 * 线上接口
 */
// 跑马灯数据
//获取任务列表
export const listBtTasks = (data) => http.post('/gw/generic/zc/h5/m/listBtTasks', data, null, {cutData: false})
//获取往期列表
export const listPastBtTasks = (data) => http.post('/gw/generic/zc/h5/m/listPastBtTasks', data, null, {cutData: false})
//领取任务   
export const receiveBtTask = (data) => http.post('/gw/generic/zc/h5/m/receiveBtTask', data, null, {cutData: false})
//任务详情
export const queryBtTaskDetail = (data) => http.post('/gw/generic/zc/h5/m/queryBtTaskDetail', data, null, {cutData: false})
//任务领奖
export const receiveBtTaskReward = (data) => http.post('/gw/generic/zc/h5/m/receiveBtTaskReward', data, null, {cutData: false})
//消费记录
export const listCountDetails = (data) => http.post('/gw/generic/zc/h5/m/listCountDetails', data, null, {cutData: false})

//乐高
export const getWaterfallsFlowForH5 = (data) => http.post('/gw/generic/aladdin/h5/m/getWaterfallsFlowForH5', data, null, {cutData: false, env: 'pro'})

//判断用户是否开通白条
export const isBtUser = (data) => http.post('/gw/generic/zc/h5/m/isBtUser', data, null, {cutData: false})

//获取当前时间
export const currentTime = (data) => http.post('/gw/generic/zc/h5/m/currentTime', data, null, {cutData: false})
